import React from "react";

const TexCell = ({ text }) => {
  return <td className="p-4 py-3 text-sm text-gray-800 ">{text}</td>;
};

export default TexCell;
